var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-notification-panel-items"},_vm._l((_vm.items),function(item){return _c(_setup.NotificationPanelItem,{key:item.countType,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }